module.exports = __webpack_public_path__ + "img/qy_4.6f28501d.png";